<template>
  <div>
      <el-cascader
          size="small"
          :options="RegionList"
          :props="{ checkStrictly: true }"
          v-model="query.region"
          placeholder="请选择省市"

          clearable>
      </el-cascader>
    <el-select class="search-el" size="small" v-model="query.status" placeholder="审核状态" :clearable="true">
      <el-option label="正常" value="1"></el-option>
      <el-option label="审批中" value="0"></el-option>
      <el-option label="冻结解除" value="2"></el-option>
    </el-select>
    <el-select class="search-el" size="small" v-model="query.role_type" placeholder="代理级别" :clearable="true">
      <el-option label="省代" value="province"></el-option>
      <el-option label="市代" value="city"></el-option>
      <el-option label="幸福驿站" value="courier"></el-option>
      <el-option label="公司总部" value="company"></el-option>
      <el-option label="区县代" value="district"></el-option>
      <el-option label="遇见合伙人" value="personal"></el-option>
      <el-option label="研修班学员" value="EPBS"></el-option>
      <el-option label="高级研修班学员" value="SPBS"></el-option>
    </el-select>
    <el-date-picker class="search-el" size="small" v-model="query.date_timestamp" value-format='yyyy-MM-dd HH:mm:ss' type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" :clearable="true">
    </el-date-picker>
    <el-button type="primary" size="small" @click="getList()">
      查询
    </el-button>

    <el-button type="primary" size="small" @click="sendMessageSubmit()">
      发送短信通知
    </el-button>
    <el-row>
      <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
        <el-table-column prop="id" label="ID" align="center" width="70"></el-table-column>
        <el-table-column prop="name" label="会名" align="center"></el-table-column>
        <el-table-column prop="real_name" label="会长名称" align="center"></el-table-column>
        <el-table-column prop="nickname" label="会长昵称" align="center"></el-table-column>
        <el-table-column prop="region_str" label="所属地区" align="center"></el-table-column>
        <el-table-column prop="role_type_msg" label="级别" align="center"></el-table-column>
        <el-table-column prop="created_at" label="入驻时间" align="center" ></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  onlineOffline,
  getAgentList,
  addChoice,
  deleteMoment
} from "@/api/agent";
import {getProvinceCityList} from "../../api/agent";

export default {
  data: function() {
    return {
      list: [],
      RegionList: [],
      loading: false,
      regionLoading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        status: "",
        role_type: "",
        date_timestamp: [],
        is_send_message: 1,//1不是发短信 2 是发短信
        region: [],//1不是发短信 2 是发短信
        temp_id: 0,
      },
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
    };
  },
  created: function() {
    this.getList();
    this.getRegionList();
  },
  methods: {
    toChildren(id) {
      this.$router.push({
        path: '/moment/info',
        query: {
          id: id,
        }
      })
    },
    deleteMoment(id) {
      this.$confirm("此操作将删除该动态, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteMoment({
          moment_id: id
        }).then(response => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        });
      });
    },
    choiceHandle(id) {
      addChoice({
        moment_id: id
      }).then(response => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success"
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          });
        }
      });
    },
    onlineOffline(id) {
      onlineOffline({
        moment_id: id
      }).then(response => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success"
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          });
        }
      });
    },
    ref() {
      window.history.go(0);
    },
    getList() {
      this.loading = true;
      this.query.is_send_message = 1;
      getAgentList(this.query).then(response => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    getRegionList() {
      this.regionLoading = true;
      getProvinceCityList(this.query).then(response => {
        this.RegionList = response.data;
        this.regionLoading = false;
      });
    },

    sendMessageSubmit() {//发送短信
      this.$prompt("请输入正确的短信模板ID", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
          .then(({ value }) => {
            this.query.temp_id = value;
            this.query.is_send_message = 2;
            getAgentList(this.query).then((response) => {
              if (response.status == 2000) {
                this.$message({
                  showClose: true,
                  message: "发送任务创建成功",
                  type: "success",
                });
              } else {
                /*this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });*/
              }
            });
          })
          .catch(() => {});
    },
  }
};
</script>

